import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faPhone,
  faPhoneVolume,
  faBuilding,
  faTrophy,
  faCircleXmark,
  faFolderOpen,
  faCalendarDays,
  faClock,
  faPhoneSlash,
  faComments,
  faFileInvoice,
  faHandshake,
  faArrowsRotate,
  faMagnifyingGlass,
  faRotateLeft,
  faChartLine,
  faListCheck,
  faArrowRight,
  faSpinner,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";

import Prince from "../../Components/Prince";
import TopHeader from "../../Components/TopHeader";
import Loader from "../../assets/img/loader.gif";
import DateFilter from "../../Components/DateFilter";

import { DataContext } from "../../context/DataContext";
import * as dashboardService from "../../Services/dashboardService";

import "../../assets/css/common.css";
// import "../../assets/css/salesdashboard.css";

import TodoListCard from "./b2btodaymetting";
import B2CTodoListCard from "./b2ctodaymetting";
import Select from "react-select";

const formatNumber = (value) => Number(value || 0).toLocaleString("en-IN");

const dashboardSections = [
  {
    title: "Today's Activity",
    subtitle: "Calls and follow-up activities",
    icon: faPhoneVolume,
    className: "activity",
    metrics: [
      {
        label: "Follow-up Calls",
        key: "followUpCallCount",
        icon: faPhone,
        color: "blue",
      },
      {
        label: "New Calls",
        key: "newCallCount",
        icon: faPhoneVolume,
        color: "teal",
      },
      {
        label: "Overdue Activities",
        key: "overDueActivityCount",
        icon: faClock,
        color: "red",
      },
      {
        label: "Pending Activities",
        key: "pendingActivityCount",
        icon: faCalendarDays,
        color: "orange",
      },
    ],
  },
  {
    title: "Lead Pipeline",
    subtitle: "Lead status-wise distribution",
    icon: faHandshake,
    className: "pipeline",
    metrics: [
      {
        label: "New",
        key: "newLeadCount",
        icon: faFolderOpen,
        color: "blue",
      },
      {
        label: "Call Attempted",
        key: "callattemptedLeadCount",
        icon: faPhoneSlash,
        color: "purple",
      },
      {
        label: "Contact in Future",
        key: "contactinfutureLeadCount",
        icon: faCalendarDays,
        color: "teal",
      },
      {
        label: "Follow Up",
        key: "followUPCount",
        icon: faComments,
        color: "orange",
      },
      {
        label: "Proposal",
        key: "proposalLeadCount",
        icon: faFileInvoice,
        color: "blue",
      },
      {
        label: "Negotiation",
        key: "negotiationLeadCount",
        icon: faHandshake,
        color: "purple",
      },
      {
        label: "In Integration",
        key: "integrationinprogressLeadCount",
        icon: faArrowsRotate,
        color: "teal",
      },
      {
        label: "Closed Won / SYTS",
        key: "closeCount",
        icon: faTrophy,
        color: "green",
      },
      {
        label: "KYC Complete",
        key: "kycLeadCount",
        icon: faUsers,
        color: "navy",
      },
    ],
  },
];

const SummaryCard = ({ icon, label, value, color }) => (
  <div className={`sales-summary-card sales-summary-${color}`}>
    <div className={`sales-summary-icon sales-icon-${color}`}>
      <FontAwesomeIcon icon={icon} />
    </div>

    <div className="sales-summary-info">
      <span>{label}</span>
      <strong>{formatNumber(value)}</strong>
    </div>
  </div>
);

const MetricCard = ({ metric, value, onClick }) => (
  <div
    className={`sales-metric-card sales-${metric.color}`}
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <div className="sales-metric-icon">
      <FontAwesomeIcon icon={metric.icon} />
    </div>

    <div className="sales-metric-content">
      <span className="sales-metric-label">{metric.label}</span>
      <strong>{formatNumber(value)}</strong>
    </div>

    <div className="sales-metric-arrow">
      <FontAwesomeIcon icon={faArrowRight} />
    </div>
  </div>
);

export const B2CLeadDashboard = ({ onSwitchAccount }) => {
  const navigate = useNavigate();
  const context = useContext(DataContext);

  const employeeData = context?.employeeData || context?.userData || {};
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [dashboardData, setDashboardData] = useState({});
  const [todoList, setTodoList] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingTodo, setLoadingTodo] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [dateForApi, setDateForApi] = useState({
    from: "",
    to: "",
  });
  const [status, setStatus] = useState("");
  const handleMetricClick = (metric) => {
    const tabMapping = {
      newLeadCount: "new",
      callattemptedLeadCount: "call-attempted",
      contactinfutureLeadCount: "contact-in-future",
      followUPCount: "follow-up",
      proposalLeadCount: "proposal",
      negotiationLeadCount: "negotiation",
      integrationinprogressLeadCount: "integration-inprogress",
      closeCount: "closed-won-SYTS",
    };

    const activeTab = tabMapping[metric.key];

    if (!activeTab) return;

    navigate("/b2c/lead", {
      state: {
        activeTab,
      },
    });
  };
  const handleResetFilters = () => {
    const isAlreadyReset =
      !fromDate &&
      !toDate &&
      !dateForApi.from &&
      !dateForApi.to &&
      !selectedEmployee &&
      !status;

    setFromDate("");
    setToDate("");
    setSelectedEmployee("");
    setStatus("");

    setDateForApi({
      from: "",
      to: "",
    });

    // if filter already reset then reload the dashoard
    if (isAlreadyReset) {
      fetchDashboardData();
    }
  };

  //   const handleB2CSwitch = () => {
  //     navigate("");
  //   };
  const [search, setSearch] = useState("");

  const isAdmin = String(employeeData?.userType) === "1";

  const canSwitchDashboard =
    String(employeeData?.userType) === "1" ||
    String(employeeData?.accountType) === "3";

  // Fetch today's follow-up activities
  const fetchTodaysFollowUps = useCallback(async () => {
    setLoadingTodo(true);

    try {
      const response = await dashboardService.getB2CTodaysFollowUps();

      const payload = response?.data?.data;

      setTodoList(Array.isArray(payload) ? payload : []);
    } catch (error) {
      console.error("Failed to load today's follow-ups:", error);
      setTodoList([]);
    } finally {
      setLoadingTodo(false);
    }
  }, []);

  // Fetch dashboard data
  const fetchDashboardData = useCallback(async () => {
    // Dono dates select hona compulsory hai
    if (dateForApi?.from && !dateForApi?.to) return;

    setLoading(true);

    try {
      const response = await dashboardService.getb2cEmployeeDashboard({
        id: selectedEmployee || "",
        from: dateForApi?.from || "",
        to: dateForApi?.to || "",
      });

      const payload = response?.data?.data;

      setDashboardData(payload && typeof payload === "object" ? payload : {});
    } catch (error) {
      console.error("Failed to load B2B dashboard:", error);
      setDashboardData({});
    } finally {
      setLoading(false);
    }
  }, [selectedEmployee, dateForApi]);

  const fetchEmployeeDropdown = useCallback(async () => {
    try {
      // console.log("Employee Dropdown API Calling...");

      const response = await dashboardService.getEmployeeDropdown();

      // console.log("Employee Dropdown API Response:", response);
      // console.log("Response Data:", response?.data);

      const payload = response?.data?.data;

      // console.log("Employee Dropdown Payload:", payload);

      setEmployeeOptions(
        Array.isArray(payload)
          ? payload
          : Array.isArray(response?.data)
            ? response.data
            : [],
      );
    } catch (error) {
      console.error(
        "Employee Dropdown API Error:",
        error.response?.data || error.message,
      );

      setEmployeeOptions([]);
    }
  }, []);

  useEffect(() => {
    fetchEmployeeDropdown();
  }, [fetchEmployeeDropdown]);

  useEffect(() => {
    fetchTodaysFollowUps();
  }, [fetchTodaysFollowUps]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  // Search within activity and pipeline metrics
  const visibleSections = useMemo(() => {
    const query = search.trim().toLowerCase();

    if (!query) return dashboardSections;

    return dashboardSections
      .map((section) => ({
        ...section,
        metrics: section.metrics.filter((metric) =>
          metric.label.toLowerCase().includes(query),
        ),
      }))
      .filter((section) => section.metrics.length > 0);
  }, [search]);

  const handleReset = () => {
    setSearch("");
    setSelectedEmployee("");
    setDateForApi({
      from: "",
      to: "",
    });
  };

  const handleRefresh = () => {
    fetchDashboardData();
    fetchTodaysFollowUps();
  };

  return (
    <div className="pages sales-dashboard-page">
      <TopHeader />
      <Prince />

      {loading && (
        <div className="loading-overlay">
          <img src={Loader} alt="Loading..." />
        </div>
      )}

      <main className="sales-dashboard">
        {/* PAGE HEADER */}
        <div className="sales-page-header">
          <div className="sales-heading-content">
            <div className="sales-heading-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>

            <div>
              <h2>B2C Sales Dashboard</h2>
              <p>Monitor leads, calls, follow-ups and your sales pipeline.</p>
            </div>
          </div>

          <button
            type="button"
            className="sales-btn sales-btn-primary"
            onClick={handleRefresh}
            disabled={loading || loadingTodo}
          >
            <FontAwesomeIcon
              icon={loading || loadingTodo ? faSpinner : faArrowsRotate}
              spin={loading || loadingTodo}
            />
            Refresh
          </button>
        </div>

        {/* FILTER PANEL */}

        <section className="bcd-top-controls">
          <div className="bcd-top-control bcd-date-control">
            <label>
              <FontAwesomeIcon icon={faCalendarDays} />
              From Date
            </label>

            <input
              type="date"
              value={fromDate}
              max={toDate || undefined}
              onChange={(event) => {
                const value = event.target.value;

                setFromDate(value);

                // when select from date api not call
                if (!value) {
                  setToDate("");
                  setDateForApi({ from: "", to: "" });
                }
              }}
            />
          </div>

          <div className="bcd-top-control bcd-date-control">
            <label>
              <FontAwesomeIcon icon={faCalendarDays} />
              To Date
            </label>

            <input
              type="date"
              value={toDate}
              min={fromDate || undefined}
              onChange={(event) => {
                const value = event.target.value;

                setToDate(value);

                // both date select then api trigger
                if (fromDate && value) {
                  setDateForApi({
                    from: fromDate,
                    to: value,
                  });
                }
              }}
            />
          </div>

          <div className="bcd-top-control bcd-employee-control">
            <label>
              <FontAwesomeIcon icon={faUsers} />
              Employee
            </label>

            <Select
              options={[
                // { value: "", label: "All Employees" },
                ...employeeOptions.map((employee) => ({
                  value: String(employee.id),
                  label: employee.name,
                })),
              ]}
              value={[
                { value: "", label: "All Employees" },
                ...employeeOptions.map((employee) => ({
                  value: String(employee.id),
                  label: employee.name,
                })),
              ].find((option) => option.value === String(selectedEmployee))}
              onChange={(option) => setSelectedEmployee(option?.value || "")}
              placeholder="Search Employee..."
              isSearchable
              isClearable={false}
              classNamePrefix="employee-select"
              noOptionsMessage={() => "No employee found"}
            />
          </div>

          <button
            type="button"
            className="bcd-btn bcd-btn-light bcd-reset-btn"
            onClick={handleResetFilters}
          >
            Reset Filters
          </button>

          {/* <div className="bcd-account-switch">
            <button type="button" className="active" aria-current="page">
              B2B
            </button>

            <button type="button" onClick={handleB2CSwitch}>
              B2C
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div> */}
          <div className="bcd-account-switch">
            <button type="button" className="active" aria-current="page">
              B2C
            </button>
            <button type="button" onClick={() => onSwitchAccount("B2B")}>
              B2B
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        </section>

        {/* TOTAL TEAM MEMBERS - SEPARATE TOP CARD */}
        {isAdmin && (
          <section className="sales-team-section">
            <div className="sales-team-card">
              <div className="sales-team-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>

              <div className="sales-team-info">
                <span>Total Team Members</span>
                <strong>{formatNumber(dashboardData?.staffCount)}</strong>
                <small>Team overview</small>
              </div>

              <div className="sales-team-decoration">
                <FontAwesomeIcon icon={faUsers} />
              </div>
            </div>
          </section>
        )}

        <section className="sales-section sales-todo-section">
          <div className="sales-section-heading">
            <div className="sales-section-heading-icon sales-todo-heading-icon">
              <FontAwesomeIcon icon={faListCheck} />
            </div>

            <div>
              <h3>Today's To-Do List</h3>
              <p>Today's scheduled calls, meetings and follow-up activities.</p>
            </div>

            <span className="sales-section-count">
              {formatNumber(todoList.length)} Activities
            </span>
          </div>

          <div className="sales-todo-content">
            {loadingTodo ? (
              <div className="sales-todo-loading">
                <FontAwesomeIcon icon={faSpinner} spin />
                <span>Loading today's activities...</span>
              </div>
            ) : todoList.length > 0 ? (
              <div className="sales-todo-scroll">
                {/* <TodoListCard todoList={todoList} loading={loadingTodo} /> */}
                <B2CTodoListCard todoList={todoList} loading={loadingTodo} />
              </div>
            ) : (
              <div className="sales-todo-empty">
                <div className="sales-todo-empty-icon">
                  <FontAwesomeIcon icon={faCalendarDays} />
                </div>
                <h4>No activities for today</h4>
                <p>Your scheduled calls and meetings will appear here.</p>
              </div>
            )}
          </div>
        </section>

        {/* LEAD OVERVIEW / SUMMARY */}
        <section className="sales-section sales-overview-section">
          <div className="sales-section-heading">
            <div className="sales-section-heading-icon">
              <FontAwesomeIcon icon={faChartLine} />
            </div>

            <div>
              <h3>Lead Overview</h3>
              <p>Quick overview of your overall lead performance.</p>
            </div>
          </div>

          <div className="sales-summary-grid">
            <SummaryCard
              icon={faFolderOpen}
              label="All Leads"
              value={dashboardData?.openLeadCount}
              color="blue"
            />

            <SummaryCard
              icon={faTrophy}
              label="Won Leads"
              value={dashboardData?.wonLeadCount}
              color="green"
            />

            <SummaryCard
              icon={faCircleXmark}
              label="Lost Leads"
              value={dashboardData?.lostLeadCount}
              color="red"
            />
          </div>
        </section>

        {/* ACTIVITY AND PIPELINE */}
        {visibleSections.length > 0 ? (
          visibleSections.map((section) => (
            <section
              className={`sales-section sales-section-${section.className}`}
              key={section.title}
            >
              <div className="sales-section-heading">
                <div className="sales-section-heading-icon">
                  <FontAwesomeIcon icon={section.icon} />
                </div>

                <div>
                  <h3>{section.title}</h3>
                  <p>{section.subtitle}</p>
                </div>

                <span className="sales-section-count">
                  {section.metrics.length} Metrics
                </span>
              </div>

              <div className="sales-metrics-grid">
                {section.metrics.map((metric) => (
                  <MetricCard
                    key={metric.key}
                    metric={metric}
                    value={dashboardData?.[metric.key]}
                    onClick={() => handleMetricClick(metric)}
                  />
                ))}
              </div>
            </section>
          ))
        ) : (
          <div className="sales-empty-search">
            <FontAwesomeIcon icon={faMagnifyingGlass} />
            <h3>No metrics found</h3>
            <p>Try searching with a different metric name.</p>
          </div>
        )}

        {/* TODAY'S TO-DO LIST */}

        {/* FOOTER */}
        <footer className="sales-footer">
          <span>
            <FontAwesomeIcon icon={faBuilding} />
            B2C Sales Overview
          </span>

          <span>
            <FontAwesomeIcon icon={faBuilding} />
            Copyright © 2024 FSHIP. Developed by FSHIP. All rights reserved.
          </span>

          <span>
            <FontAwesomeIcon icon={faClock} />
            Dashboard data is based on selected filters.
          </span>
        </footer>
      </main>
    </div>
  );
};
